import Checkbox from 'Shared/components/Checkbox'
import './SurveyPageForm.scoped.scss'
import questionTypes from './question-types'
import AsyncSelect from 'Shared/components/AsyncSelect'

export default function AfterQuestionActions({question, updateQuestion}){
  const questionConfig = questionTypes[question.questionType]

  const [showUpdateField, setShowUpdateField] = useState(!!question.updatesCustomFieldId)

  if(!questionConfig.customFieldKind) {
    return null
  }

  return (
    <div className="flex column gap-10 no-margin-bottom">
      <div className="flex-center gap-10">
        <strong>After question</strong>
        <Checkbox
          card
          label="Update custom field"
          className="no-margin-bottom"
          checked={showUpdateField}
          onChange={(e) => setShowUpdateField(e.target.checked)}
        />
      </div>

      {showUpdateField &&
        <div className="after-question-action flex-center gap-10">
          <label>Updates custom field</label>
          <p className='smaller dark-grey'>Updates a custom field from the answer given</p>
          <AsyncSelect
            entity="custom_field"
            value={question.updatesCustomFieldId}
            rootClassName="root grow"
            classNamePrefix="custom-field-select"
            onChange={(id) => updateQuestion({ updatesCustomFieldId: id })}
            queryParameters={{kind: questionConfig.customFieldKind}}
          />
        </div>
      }
    </div>
  )
}
